import { useEffect, useState } from "react";

import { ApiCallStatus, CONSENTS_ENDPOINT, ConsentsListItemApi } from "../api-http";
import { getConsentsApiClient } from "../api-http/api-client";

// Note locale needs to be a Contentful Locale, not an API locale
export function useGetConsents(locale: string): [ConsentsListItemApi[] | null, ApiCallStatus] {
  const [result, setResult] = useState<ConsentsListItemApi[] | null>(null);
  const [status, setStatus] = useState<ApiCallStatus>(ApiCallStatus.LOADING);
  useEffect(() => {
    // I am in the browser
    getConsentsApiClient()
      .get<{ items: ConsentsListItemApi[] }>(CONSENTS_ENDPOINT, {
        headers: {
          "Accept-Language": locale,
        },
      })
      .then((response) => {
        setResult(response.data?.items?.filter(Boolean) ?? null);
        setStatus(ApiCallStatus.SUCCESS);
      })
      .catch((e) => {
        console.log(e);
        setStatus(ApiCallStatus.FAILED);
      });
  }, [locale]);

  return [result, status];
}
